import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { fetchApi } from 'core/utils/api';
import './guestBooking.scss';

/**
 * Entry point for a one-off guest booking link. Validates the token, then sends
 * the guest into the request form for the type of request the link was issued
 * for (visit, general access or guarding).
 *
 * The opening step comes from the API rather than being hardcoded: the site and
 * work types are already set, but which screen comes first differs by request
 * type, and retail sites reorder the chain again.
 */
const GuestBooking: React.FC = () => {
    const { token } = useParams<{ token: string }>();
    const navigate = useNavigate();
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        let active = true;

        const load = async () => {
            try {
                const response = await fetchApi({ method: 'GET', url: `booking/${token}` });
                if (active) {
                    const firstStep = response.data?.currentStep || 2;
                    navigate(`/booking/${token}/step/${firstStep}`, { replace: true });
                }
            } catch (e) {
                if (active) {
                    // Shown full-page below — no toast, to avoid doubling up.
                    setError('This link is invalid or has expired.');
                }
            }
        };

        load();

        return () => { active = false; };
    }, [token, navigate]);

    return (
        <div className="guest-booking">
            <p className="guest-booking__message">{error || 'Loading your booking…'}</p>
        </div>
    );
};

export default GuestBooking;
